import i18n from '../localization/i18n'
import _ from 'lodash'

const defaultOptions = {
    abortEarly: false
}

export function validate(schema, obj, options = {}) {
    if (!_.isFunction(schema.validate)) {
        throw new Error('schema must contains "validate" method')
    }

    const resultOptions = {
        ...defaultOptions,
        ...options
    }

    return schema.validate(obj, resultOptions)
}

export function hasErrors(validationResult) {
    return _.has(validationResult, ['error'])
}

const pluralizeChoiceByRuleTypes = {
    'string.min': 'limit',
    'string.max': 'limit',
    'array.min': 'limit',
    'array.max': 'limit',
    'array.length': 'limit'
}

export function extractErrorMessages(validationResult, byFields = false) {
    let result = []

    if (byFields) {
        result = {}
    }

    const details = _.get(validationResult, ['error', 'details'], [])

    for (let detail of details) {
        const path = _.get(detail, 'path', '')
        const type = _.get(detail, 'type', null)
        const context = _.get(detail, 'context', {})
        const errorMessageLocalizationKey = buildErrorMessageLocalizationKey(type)
        const translatedMessage = i18n.tc(errorMessageLocalizationKey, _.get(context, pluralizeChoiceByRuleTypes[type], null), context)

        let resultMessage = translatedMessage
        if (translatedMessage === errorMessageLocalizationKey) {
            resultMessage = detail.message
        }

        resultMessage = _.upperFirst(resultMessage)

        if (!byFields) {
            result.push(resultMessage)
            continue
        }

        if (!path) {
            continue
        }

        let errorsByPath = result[path] || []
        errorsByPath.push(resultMessage)

        result[path] = errorsByPath
    }

    return result
}

function buildErrorMessageLocalizationKey(type) {
    return `validation.${type}`
}


export function validateStringLength(value, maxLength, message) {
    if (!value) {
        return true
    }

    if (value.length > maxLength) {
        return message
    }

    return true
}

